import {useState, useEffect, useContext} from 'react';
import axios from "../../utils/axios";
import {AlertContext} from "../../contexts/AlertContext";

export default function useGetSections(path, filter) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {initAlert} = useContext(AlertContext);

  const fetchData = async (flag = true) => {
    try {
      flag && setLoading(true);
      const response = await axios.get(`/secciones/secciones_por_path_estado?path=${path}&estado=true`);
      filter ? setSections(response.data.data.filter(x => x.Seccion === filter)) : setSections(response.data.data)
      flag && setLoading(false);
    } catch (err) {
      setError(err);
      initAlert(true, 'error', 'Ocurrio un error, por favor intenta de nuevo...')
      flag && setLoading(false);
    }
  }

  useEffect(() => {
    fetchData()
  }, [])
  return [sections, loading, error];
}
